import { useDepositToPortfolioMutation } from 'hooks/mutations/Rewards/useDepositToPortfolioMutation'
import { useRewardsTracking } from 'pages/Rewards/hooks/useRewardsTracking'
import { BaseErrorResponse } from 'types/beneficiaries'
import { DepositRequest, DepositTransferResponse } from 'types/rewards'

export const useDepositPortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: DepositTransferResponse) => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()
  const { mutate: depositToPortfolio, isPending: isDepositingToPortfolioPending } =
    useDepositToPortfolioMutation()

  const handleDepositToPortfolio = (data: DepositRequest) => {
    const {
      originator: { walletId, amount },
    } = data

    return depositToPortfolio(data, {
      onSuccess: data => {
        trackSuccess('allocate', {
          walletId,
          amount,
        })
        onSuccess?.(data)
      },
      onError: (error: BaseErrorResponse) => {
        trackError('allocate', error, {
          walletId,
          amount,
        })
        onError?.(error)
      },
    })
  }

  return {
    depositToPortfolio: handleDepositToPortfolio,
    isDepositingToPortfolioPending,
  }
}
